import React from "react"
import "./accounts.css"
import ApiService from "../../../Services/ApiService.js"
import Papa from "papaparse"
import ReactTable from "react-table";
import AlertService from "../../../Services/AlertService";
import queryString from "query-string";

class SecondaryAccounts extends React.Component {

    state = {
        client_id: '',
        campaign_id: '',
        account_id: -1,
        account_name: '',
        secondary_companies: [],
        csvFile: null,
        theInputKey: ''


    };

    componentDidMount = () => {
        let params = queryString.parse(this.props.location.search);
        if (params) {
            let clientId = params.client_id;
            let campaignId = params.campaign_id;
            this.setState({
                ...this.state,
                client_id: clientId,
                campaign_id: campaignId,
            }, () => {
                this.fetchSecondaryAccounts();
            });
        }
    }

    fetchSecondaryAccounts()
    {
        ApiService.post('/api/campaigns/secondary-companies', {
            'campaign_id': this.state.campaign_id
        })
            .then(response => {
                this.setState({...this.state, secondary_companies: response.data})
            })
    }

    handleFileChange(e) {
        this.setState({...this.state,
            csvFile: e.target.files[0]

        })
    }

    deleteSecondaryAccount = (id) => {
        ApiService.post('/api/campaigns/delete-secondary-company', {'id': id})
            .then(response => {
                let currentState = this.state.secondary_companies;
                let index = currentState.findIndex(account => account.ID === id);
                if (index > -1) {
                    currentState.splice(index, 1);
                    this.setState({...this.state, secondary_companies: currentState})
                }
            })
    }

    async addSecondaryAccount()
    {
        if (this.state.account_id > -1) {
            ApiService.post('/api/campaigns/add-secondary-company', {
                'campaign_id': this.state.campaign_id,
                'company_id': this.state.account_id,
                'name': this.state.account_name
            })
                .then(async (response) => {
                    console.log(response);

                    var newAccount = {
                        ID: response.data.ID,
                        company_id: response.data.LinkedInCompanyId,
                        name: response.data.CompanyName,
                    };

                    await this.setState(prevState => ({
                        secondary_companies: [...prevState.secondary_companies, newAccount]
                    }));
                })

        }
    }

    uploadFile()
    {
        if (this.state.csvFile) {
            Papa.parse(this.state.csvFile, {
                complete: this.parseFile.bind(this),
                header: true
            })
        }

        // reset the file input
        let randomString = Math.random().toString(36);
        this.setState({...this.state,  theInputKey: randomString})

    }

    async parseFile(result) {
        var fileData = result.data;
        var secondaryCompanies = [];

        for (var i = 0; i < fileData.length; i++) {
            var name = fileData[i].Name;
            var url = fileData[i].URL;

            if (url !== "") {

                var response = await ApiService.get('/api/linkedin/companies?search=' + url +'&client_id=' + this.state.client_id);
                if (response.data.matches.length > 0 && response.data.matches[0].localizedName !== "undefined") {
                    this.setState({
                        ...this.state,
                        account_id: response.data.matches[0].id,
                        account_name: response.data.matches[0].localizedName
                    }, async () => {
                        let index = this.state.secondary_companies.findIndex(account => account.company_id == this.state.account_id);
                        if (index === -1) {
                            await this.addSecondaryAccount();
                        }
                    });

                }
            }
        }

    }

    render() {
        const columns = [
            {
                Header: "Company Name",
                accessor: "name",
                width: 250
            },
            {
                Header: "Actions",
                Cell: (data) => {
                    let id = data.row._original.ID;
                    return (
                        <div>
                            <button className="table-btn" onClick={() => this.deleteSecondaryAccount(id)}> <i className="fa fa-trash-o"></i> </button>
                        </div>
                    )
                }
            }
        ];

        let secondaryAccountsListing = null;

        if (this.state.secondary_companies.length !== 0) {
            secondaryAccountsListing= (
                <ReactTable
                    data={this.state.secondary_companies}
                    columns={columns}
                    showPagination={false}
                    minRows={0}
                    />
            )
        }


        return(
            <div className="page-content">
                <div className="account-container">
                <div>
                <h3> Secondary Accounts Bulk File Upload</h3>
            </div>

            <div className="accounts-ads">
                <div className="section upload-file-section">
                    <input id="upload-file" type="file" accept=".xls, .xslx, .csv" onChange={(e)=>this.handleFileChange(e)} key={this.state.theInputKey || '' }/ >
                    <button onClick={this.uploadFile.bind(this)}>Upload File</button>
                </div>
            </div>
            <div className="table-style">
                {secondaryAccountsListing}
            </div>
            <div className="form-submit">
                <button type="button" className="outline"
                 onClick = {() => {this.props.history.push("/campaignGroup/accounts?client_id="+ this.state.client_id
                    + "&campaign_id=" + this.state.campaign_id)}}>
                    Back
                </button>
            </div>
        </div>
        </div>
        )
    }
}

export default SecondaryAccounts;